import {AfterViewInit, Component, inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {LpIconComponent} from '../../common/lp/lp-icon/lp-icon.component';
import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';
import {WINDOW} from '../../../config/module.di.tokens';

@Component({
  selector: 'app-home-digits',
  imports: [
    NgForOf,
    LpIconComponent,
    NgIf
  ],
  templateUrl: './home-digits.component.html',
  styleUrls: ['./home-digits.component.scss']
})
export class HomeDigitsComponent implements AfterViewInit {

  window = inject(WINDOW)
  platformId = inject(PLATFORM_ID)
  swiper: Swiper
  digits = [
    {icon: "star", title: "+ de 1700", text: "célibataires nous ont déja fait confiance et témoignent."},
    {icon: "heart", title: "72%", text: "célibataires ayant reçu un ou plusieurs coups de coeur."},
    {icon: "thumb", title: "92%", text: "viennent des apps et changent d'avis sur le speed dating."},
    {icon: "check", title: "100%", text: "des profils vérifiés manuellement."},
  ]

  async ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.window.innerWidth <= 640) {
        setTimeout(() => {
          this.swiper = new Swiper(".digits-carousel", {
            loop: true,
            autoplay: {
              delay: 2000,
              disableOnInteraction: false,
            },
            speed: 350,
            modules: [Autoplay],
          });

        }, 600)

      }
    }
  }


}
